import CMSComponent from "../../../components/CMSComponent";
import H3 from "../../../components/global/H3";
import Button from "../../../components/global/Button";
import SplitContent from "../../../components/layout/SplitContent";
import { P } from "../../../components/text/TextComponents";
import { css } from "emotion";
import { max } from "../../../utils/CssUtils";

const impactImage = require("../../../assets/Pricing/impact.jpg");
const impactImage2x = require("../../../assets/Pricing/impact2x.jpg");
const impactImage3x = require("../../../assets/Pricing/impact3x.jpg");

const wrapper = css({
  [max(768)]: {
    paddingTop: 32
  }
});

const SocialImpact = ({ contentData, locale }) => {
  return (
    <SplitContent
      bgColor="white"
      image={impactImage}
      imageSrcSet={[impactImage2x, impactImage3x]}
      right={false}
      alt="Images of children"
    >
      <div className={wrapper}>
        <H3>Did we mention we’re a not for profit?</H3>
        <P>
          We don’t have shareholders to pay. That’s why we can charge less,
          cover our costs, and direct everything else to projects that help give
          disadvantaged children all over the world get access to education,
          opportunity and a fair-go in life.
        </P>
        <P>
          When setting up your event, simply pick from one of three education
          projects to support at no extra cost to you.
        </P>
        <Button
          size="large"
          link={`/${locale}/our-projects`}
          ariaLabel="See projects"
        >
          See projects
        </Button>
      </div>
    </SplitContent>
  );
};

export default CMSComponent("socialImpact", SocialImpact, 504);
